// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3F4sA","inner":"Footer_inner__17EWZ","nextIcon":"Footer_nextIcon__3o80x","innerLeft":"Footer_innerLeft__3BBTy"};